import cn from 'clsx';
import React from 'react';
import { Image, UIText3, useDeviceType } from '@cian/ui-kit';
import styles from './styles.css';
import { ILabel } from 'shared/types/common/offer';

export interface ILabelListProps {
  labels: ILabel[];
}

export const LabelList: React.FC<ILabelListProps> = ({ labels }) => {
  const deviceType = useDeviceType();

  return (
    <ul className={styles['wrapper']}>
      {labels.map((el, index) => {
        return (
          <li key={index} className={cn(styles['item'], styles[el.type])}>
            <div className={cn(styles['icon'], styles[deviceType])}>
              <Image src={el.iconPath} alt={el.text} preloader />
            </div>
            <UIText3 color={'current_color'}>{el.text}</UIText3>
          </li>
        );
      })}
    </ul>
  );
};
